import sys from "./modules/sys";
import sysUser from './modules/sysUser'
import sysPermission from './modules/sysPermission';
import sysUserRole from './modules/sysUserRole';
import sysDict from './modules/sysDict';
import sysOrganization from './modules/sysOrganization';
import common from './modules/common';
import sysUserOrganization from './modules/sysUserOrganization';
import sysDataPermission from './modules/sysDataPermission';
import sysRolePermission from './modules/sysRolePermission';
import sysRole from './modules/sysRole';
import importDingTalk from './modules/importDingTalk';
import achievement from './modules/achievement';
import classList from './modules/class';
import student from './modules/student';
import bizClassRoom from "./modules/bizClassRoom";
import sysSetting from "./modules/sysSetting";
import school from "./modules/school";
import exam from "./modules/exam";
import attendance from "./modules/attendance";
import studentRecords from "./modules/studentRecords";
import tansfer from "./modules/tansfer";
import outsourcingUser from "./modules/outsourcingUser";
import clew from "./modules/clew";
import follow from "./modules/follow";
import payRecord from "./modules/payRecord";
import dingtalk from "./modules/dingtalk";

import test from './modules/test'

export default {
    sys,
    sysUser,
    sysPermission,
    test,
    sysUserRole,
    sysOrganization,
    sysUserOrganization,
    sysDict,
    common,
    sysDataPermission,
    sysRolePermission,
    sysRole,
    importDingTalk,
    achievement,
    classList,
    student,
    bizClassRoom,
    school,
    exam,
    sysSetting,
    attendance,
    studentRecords,
    tansfer,
    outsourcingUser,
    clew,
    follow,
    payRecord,
    dingtalk
}
